import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { ImportExportDialog } from './ImportExportDialog'
// import { DocumentProcessingDialog } from '@/components/document-processing'
import { Upload, Download, RefreshCw, Bell } from 'lucide-react'
import { useQueryClient } from '@tanstack/react-query'
// import type { SourceWithFacets } from '@/lib/api/client'

interface HeaderProps {
  title: string
}

export function Header({ title }: HeaderProps) {
  const [dialogMode, setDialogMode] = useState<'import' | 'export' | null>(null)
  // const [showDocumentDialog, setShowDocumentDialog] = useState(false)
  const queryClient = useQueryClient()

  const handleRefresh = () => {
    queryClient.invalidateQueries()
  }

  // const handleDocumentCreated = (source: SourceWithFacets) => {
  //   console.log('Source created:', source.title,
  //     `(${source.facets.length} facets)`)
  //   // Refresh queries to show new source in relevant views
  //   queryClient.invalidateQueries({ queryKey: ['sources'] })
  //   setShowDocumentDialog(false)
  // }

  // Get greeting based on time of day
  const getGreeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Good morning'
    if (hour < 18) return 'Good afternoon'
    return 'Good evening'
  }

  return (
    <>
      <header className="h-16 bg-background flex items-center justify-between px-8">
        <div className="min-w-0">
          <p className="text-sm text-text-muted">{getGreeting()}</p>
          <h1 className="text-xl font-semibold text-text">{title}</h1>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            variant="ghost"
            size="icon"
            title="Notifications"
            className="h-9 w-9 text-text-muted hover:text-text hover:bg-warm-100"
          >
            <Bell className="w-[18px] h-[18px]" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            title="Refresh"
            onClick={handleRefresh}
            className="h-9 w-9 text-text-muted hover:text-text hover:bg-warm-100"
          >
            <RefreshCw className="w-[18px] h-[18px]" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            title="Import Data"
            onClick={() => setDialogMode('import')}
            className="h-9 w-9 text-text-muted hover:text-text hover:bg-warm-100"
          >
            <Upload className="w-[18px] h-[18px]" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            title="Export Data"
            onClick={() => setDialogMode('export')}
            className="h-9 w-9 text-text-muted hover:text-text hover:bg-warm-100"
          >
            <Download className="w-[18px] h-[18px]" />
          </Button>
        </div>
      </header>

      {dialogMode && (
        <ImportExportDialog mode={dialogMode} onClose={() => setDialogMode(null)} />
      )}
    </>
  )
}
